import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { useState } from "react";
import { getEnv } from "./helper";
import useQuery from "components/customHooks/useQuery";
import { useNavigate } from "react-router-dom";
import { processPayment } from "store/actions";
import { useDispatch } from "react-redux";

const status = {
  success: "Payment succeeded!",
  failed: "Your payment is processing.",
  inProcess: "Your payment was not successful, please try again.",
  wentWrong: "Your payment was not successful, please try again.",
};
const Stripe = ({
  invoice_number,
  setClientSecret,
  partial_paid_ce_list,
  isKeyAvailable,
  invoice_payment_type,
  practice_id,
  patient_id,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  let query = useQuery();

  const process_payment = async (payload) => {
    const response = await dispatch(processPayment(payload));
    if (response) {
      // setLoading(false);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    const source = query.get("src");

    setIsLoading(true);
    let invoice_query = `?src=${source}&invoice_number=${invoice_number}`;
    const return_page =
      getEnv() === "prod"
        ? "https://billing-web.services.orcicare.com/payment-result"
        : getEnv() === "test"
        ? "https://billing-web-test.services.orcicare.com/payment-result"
        : "http://localhost:3000/payment-result";

    try {
    } catch (err) {}
    const response = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: return_page + invoice_query,
      },
      redirect: "if_required",
    });
    if (response.error) {
      const { error } = response;
      if (error?.type === "card_error" || error?.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occured.");
      }
    } else {
      const clientSecret = response.paymentIntent.client_secret;
      stripe
        .retrievePaymentIntent(clientSecret)
        .then(({ paymentIntent }) => {
          switch (paymentIntent.status) {
            case "succeeded":
              let payload = {
                payment_id: paymentIntent.id,
                invoice_number,
              };
              if (isKeyAvailable) {
                payload["partial_paid_ce_list"] = partial_paid_ce_list;
                payload["invoice_payment_type"] = invoice_payment_type;
              }
              return process_payment(payload)
                .then((res) => {
                  navigate("/payment-result", {
                    state: {
                      partial_paid_ce_list,
                      source,
                      invoice_number,
                      practice_id,
                      patient_id,
                    },
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
            case "processing":
              setMessage(status.inProcess);
              break;
            case "requires_payment_method":
              setMessage(status.failed);
              break;
            default:
              setMessage(status.wentWrong);
              break;
          }
        })
        .then(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <form className="stripe-payment-form" onSubmit={handleSubmit}>
      {message && (
        <div id="payment-message" style={{ color: "red" }}>
          {message}
        </div>
      )}
      <PaymentElement id="payment-element" />

      <div className="stripe-btn-cont">
        {isLoading ? (
          <div className="checkout-btn" id="spinner">
            Processing Payment...
          </div>
        ) : (
          <button className="checkout-btn" type="submit" disabled={!stripe}>
            Pay
          </button>
        )}
        <button
          className="back-btn"
          type="button"
          disabled={!stripe || isLoading}
          onClick={() => setClientSecret("")}
        >
          Back
        </button>
      </div>
    </form>
  );
};

export default Stripe;
